<template>
  <div>
    <b-row>
      <loading :active="isLoading" :is-full-page="true"></loading>
      <b-col>
        <b-card title="Listado de Cursos">
          <b-table class="mt-2 text-center" sticky-header no-border-collapse head-variant="light"
            style="min-height: 65vh;" striped :items="items" :fields="coursesFields" responsive>
            <template #cell(display_name)="data" :busy="isLoading" v-if="!isLoading">
              <div v-if="edit[data.index]">
                <b-form-input v-model="data.item.display_name"></b-form-input>
              </div>
              <div v-if="!edit[data.index]">
                {{ data.item.display_name }}
                <b-badge v-if="data.item.x_advanced_class" pill variant="info">adv</b-badge>
              </div>
            </template>
            <template #cell(x_advanced_class)="data" v-if="!isLoading">
              <div v-if="edit[data.index]">
                <b-form-checkbox v-model="data.item.x_advanced_class">
                  Adv
                </b-form-checkbox>
              </div>
              <div v-if="!edit[data.index]">
                {{ data.item.x_advanced_class }}
              </div>
            </template>
            <template #cell(x_attendance)="data" v-if="!isLoading">
              <div v-if="edit[data.index]">
                <b-form-input v-model="data.item.x_attendance"></b-form-input>
              </div>
              <div v-if="!edit[data.index]">
                {{ data.item.x_attendance }}%
              </div>
            </template>
            <template #cell(x_prom_score)="data" v-if="!isLoading">
              <div v-if="edit[data.index]">
                <b-form-input v-model="data.item.x_prom_score"></b-form-input>
              </div>
              <div v-if="!edit[data.index]">
                {{ data.item.x_prom_score }}
              </div>
            </template>
            <template #cell(x_enrollment_fee)="data" v-if="!isLoading">
              <div v-if="edit[data.index]">
                <b-form-input v-model="data.item.x_enrollment_fee"></b-form-input>
              </div>
              <div v-if="!edit[data.index]">
                ${{ data.item.x_enrollment_fee }}
              </div>
            </template>
            <template #cell(x_march_fee)="data" v-if="!isLoading">
              <div v-if="edit[data.index]">
                <b-form-input v-model="data.item.x_march_fee"></b-form-input>
              </div>
              <div v-if="!edit[data.index]">
                ${{ data.item.x_march_fee }}
              </div>
            </template>
            <template #cell(x_1st_fee)="data" v-if="!isLoading">
              <div v-if="edit[data.index]">
                <b-form-input v-model="data.item.x_1st_fee"></b-form-input>
              </div>
              <div v-if="!edit[data.index]">
                ${{ data.item.x_1st_fee }}
              </div>
            </template>
            <template #cell(x_2nd_fee)="data" v-if="!isLoading">
              <div v-if="edit[data.index]">
                <b-form-input v-model="data.item.x_2nd_fee"></b-form-input>
              </div>
              <div v-if="!edit[data.index]">
                ${{ data.item.x_2nd_fee }}
              </div>
            </template>
            <template #cell(x_3rd_fee)="data" v-if="!isLoading">
              <div v-if="edit[data.index]">
                <b-form-input v-model="data.item.x_3rd_fee"></b-form-input>
              </div>
              <div v-if="!edit[data.index]">
                ${{ data.item.x_3rd_fee }}
              </div>
            </template>
            <template #cell(x_december_fee)="data" v-if="!isLoading">
              <div v-if="edit[data.index]">
                <b-form-input v-model="data.item.x_december_fee"></b-form-input>
              </div>
              <div v-if="!edit[data.index]">
                ${{ data.item.x_december_fee }}
              </div>
            </template>
            <template #cell(x_classes_ids)="data">
              <div v-if="!edit[data.index]">
                {{ data.item.x_classes_ids.length }}
              </div>
            </template>
            <template #cell(actions)="data">
              <b-icon @click='guardar(data.item, data.index)' v-if="edit[data.index]" icon=check-lg
                class="h2 mb-1 px-1 btn-like-icon" hover v-b-tooltip.hover title="Guardar" variant="success"></b-icon>
              <b-icon @click='cancelar(data.index)' v-if="edit[data.index]" icon=x-lg
                class="h2 mb-1 ml-2 px-1 btn-like-icon" hover v-b-tooltip.hover title="Cancelar"
                variant="danger"></b-icon>
              <b-icon @click='editar(data.index)' v-if="!edit[data.index]" icon=pencil-square
                class="h2 mb-1 px-1 btn-like-icon" hover v-b-tooltip.hover title="Editar" variant="primary"></b-icon>
              <b-icon @click='borrar(data.item.id)' v-if="!edit[data.index]" icon=archive-fill
                class="h2 mb-1 ml-2 px-1 btn-like-icon" hover v-b-tooltip.hover title="Archivar"
                variant="primary"></b-icon>
            </template>
          </b-table>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>

import { ProductTemplateService } from '@/services/product.template.service'
import { SaleOrderLinesService } from '@/services/sale.order.lines.service'
// import { SaleOrdersService } from '@/services/sale.orders.service'
import { EnrollmentsService } from '@/services/enrollments.service'
import Loading from 'vue-loading-overlay'

export default {
  name: 'ConfigCourses',
  data () {
    return {
      isLoading: true,
      edit: {},
      items: [],
      coursesFields: [
        { key: 'display_name', label: 'Curso', sortable: true },
        { key: 'x_attendance', label: 'Asist. %' },
        { key: 'x_prom_score', label: 'Nota Prom.' },
        { key: 'x_enrollment_fee', label: 'Cuota Inscr.' },
        { key: 'x_march_fee', label: 'Cuota Marzo' },
        { key: 'x_1st_fee', label: 'Cuota 1er Hno' },
        { key: 'x_2nd_fee', label: 'Cuota 2do Hno' },
        { key: 'x_3rd_fee', label: 'Cuota 3er Hno' },
        { key: 'x_december_fee', label: 'Cuota Dic' },
        { key: 'x_classes_ids', label: 'Clases' },
        { key: 'actions', label: 'Acciones', class: 'custom-min-width-col' }
      ]
    }
  },
  watch: {

  },
  computed: {

  },
  components: {
    Loading
  },
  async created () {
    this.isLoading = true
    await this.updateLista()
    this.isLoading = false
  },
  methods: {
    async updateAccountMoves (item) {
      const date = new Date()
      date.setTime(Date.parse('01/01/2020'))
      const saleOrderLines = await SaleOrderLinesService.list([['product_template_id', '=', item.id], ['create_date', '>=', date]])
      const procesSos = {}
      for (let i = 0; i < saleOrderLines.length; i++) {
        const sol = saleOrderLines[i]
        const enrollment = await EnrollmentsService.list({ x_class_id: sol.x_class_id[0], x_student_id: sol.x_student_id[0] })
        // console.log(enrollment)
        if (enrollment.x_status === 'draft' || enrollment.x_status === 'active') {
          procesSos[sol.order_id[0]] = {}
        }
        /* const so = await SaleOrdersService.read([sol.order_id[0]])
        const soSol = await SaleOrderLinesService.read(so[0].order_line)
        console.log(sol, so, soSol) */
      }
    },
    updateLista: async function () {
      try {
        this.items = await ProductTemplateService.list(this.tableDomain)
      } catch (error) {
        console.log(error)
      }
    },
    agregar () {
      this.isLoading = true
      this.items.push({
        x_name: '',
        x_project_id: this.projectId
      })
      this.edit[this.items.length - 1] = true
      this.isLoading = false
    },
    cancelar (index) {
      this.isLoading = true
      if (!this.items[index].id) {
        this.items.splice(index, 1)
      } else {
        this.edit[index] = false
      }
      this.isLoading = false
    },
    async guardar (item, index) {
      this.isLoading = true
      if (item.id) {
        const updateItem = {
          x_short_name: item.x_short_name,
          x_advanced_class: item.x_advanced_class,
          x_attendance: item.x_attendance,
          x_prom_score: item.x_prom_score,
          x_enrollment_fee: item.x_enrollment_fee,
          x_march_fee: item.x_march_fee,
          x_1st_fee: item.x_1st_fee,
          x_2nd_fee: item.x_2nd_fee,
          x_3rd_fee: item.x_3rd_fee,
          x_december_fee: item.x_december_fee
        }
        await ProductTemplateService.update([item.id], updateItem)
        await this.updateAccountMoves(item)
      } else {
        this.itemsGroups[index].id = await ProductTemplateService.create(item)
      }
      this.edit[index] = false
      this.isLoading = false
    },
    async editar (index) {
      if (Object.keys(this.edit)[0] !== index && Object.keys(this.edit)[0] !== undefined) {
        delete this.edit[Object.keys(this.edit)[0]]
      }
      this.isLoading = true
      this.edit[index] = true
      this.isLoading = false
    },
    async borrar (id) {
      this.isLoading = true
      try {
        await ProductTemplateService.delete(id)
      } catch (error) {
        this.$bvToast.toast(error.message, {
          title: 'Error al intentar eliminar curso',
          autoHideDelay: 5000,
          variant: 'danger',
          solid: true
        })
      }

      await this.updateLista()
      this.isLoading = false
    }
  }
}
</script>

<style lang="scss" scoped></style>
